import React from "react";

const STORAGE_KEY = "cookieConsent.v1";

export default function CookiePolicy() {
  const openCookieSettings = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
    // ให้แบนเนอร์ที่เราสร้างไว้แสดงอีกครั้ง
    window.location.reload();
  };

  const today = new Date().toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="ckp-wrap">
      <header className="ckp-hero">
        <h1>นโยบายคุกกี้ (Cookie Policy)</h1>
        <p>อัปเดตล่าสุด: {today}</p>
      </header>

      <section>
        <h2>คุกกี้คืออะไร?</h2>
        <p>
          “คุกกี้” คือไฟล์ข้อมูลขนาดเล็กที่ถูกจัดเก็บไว้ในอุปกรณ์ของคุณเมื่อคุณเข้าใช้งานเว็บไซต์
          คุกกี้ช่วยให้เว็บไซต์ทำงานได้อย่างถูกต้อง จดจำการตั้งค่าของคุณ
          และช่วยให้เราปรับปรุงประสบการณ์การใช้งานให้ดียิ่งขึ้น
          นอกจากคุกกี้ เรายังอาจใช้เทคโนโลยีที่คล้ายคลึงกัน เช่น{" "}
          <strong>Local Storage / Session Storage</strong>
          เพื่อวัตถุประสงค์เดียวกัน
        </p>
      </section>

      <section>
        <h2>เราประมวลผลคุกกี้อย่างไร</h2>
        <p>
          เราเก็บและประมวลผลคุกกี้เฉพาะตามวัตถุประสงค์ที่จำเป็นต่อการให้บริการ
          และตามความยินยอมของคุณสำหรับคุกกี้ประเภทวิเคราะห์ (Analytics) และการตลาด (Marketing)
          คุณสามารถเปลี่ยนแปลงความยินยอมได้ทุกเวลาโดยกดปุ่มด้านล่าง
        </p>
        <button className="ckp-btn" onClick={openCookieSettings}>
          เปลี่ยนการตั้งค่าคุกกี้
        </button>
      </section>

      <section>
        <h2>ประเภทของคุกกี้ที่เราใช้</h2>

        <h3>1) คุกกี้ที่จำเป็น (Necessary)</h3>
        <ul>
          <li>ช่วยให้เว็บไซต์ทำงานได้ เช่น การรักษาความปลอดภัย การเข้าสู่ระบบ การบันทึกสถานะการใช้งาน</li>
          <li>ไม่สามารถปิดได้ผ่านระบบการตั้งค่าคุกกี้ เพราะจำเป็นต่อการให้บริการ</li>
        </ul>

        <h3>2) คุกกี้วิเคราะห์การใช้งาน (Analytics)</h3>
        <ul>
          <li>ช่วยให้เราเข้าใจพฤติกรรมการใช้งานของผู้ใช้ เพื่อนำไปปรับปรุงเว็บไซต์</li>
          <li>จะถูกใช้งานเมื่อคุณยินยอมเท่านั้น</li>
        </ul>

        <h3>3) คุกกี้การตลาด/โฆษณา (Marketing)</h3>
        <ul>
          <li>ใช้วัดประสิทธิภาพโฆษณา/แคมเปญ และช่วยแสดงเนื้อหาให้ตรงความสนใจ</li>
          <li>จะถูกใช้งานเมื่อคุณยินยอมเท่านั้น</li>
        </ul>
      </section>

      <section>
        <h2>รายการคุกกี้และเทคโนโลยีที่ใช้งานโดยทั่วไป</h2>
        <div className="ckp-table-wrap">
          <table className="ckp-table">
            <thead>
              <tr>
                <th>หมวดหมู่</th>
                <th>ชื่อคุกกี้/สตอเรจ</th>
                <th>ผู้ให้บริการ</th>
                <th>วัตถุประสงค์</th>
                <th>อายุการเก็บ</th>
                <th>ประเภท</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Necessary</td>
                <td><code>cookieConsent.v1</code> (Local Storage)</td>
                <td>เว็บไซต์นี้</td>
                <td>จดจำการยินยอมคุกกี้และตัวเลือกของผู้ใช้</td>
                <td>จนกว่าจะลบ</td>
                <td>First-party</td>
              </tr>
              <tr>
                <td>Necessary</td>
                <td><code>affiliateRef</code> (Local Storage)</td>
                <td>เว็บไซต์นี้</td>
                <td>จดจำรหัสผู้แนะนำ/พาร์ทเนอร์เพื่อให้ระบบทำงานได้ถูกต้อง</td>
                <td>จนกว่าจะลบ</td>
                <td>First-party</td>
              </tr>
              <tr>
                <td>Analytics</td>
                <td><code>_ga</code>, <code>_ga_&lt;container&gt;</code>, <code>_gid</code></td>
                <td>Google Analytics</td>
                <td>วิเคราะห์การใช้งานเว็บไซต์ (จะทำงานเมื่อยินยอม)</td>
                <td>_ga 2 ปี, _gid 24 ชม.</td>
                <td>Third-party</td>
              </tr>
              <tr>
                <td>Marketing</td>
                <td><code>_gcl_au</code></td>
                <td>Google Ads</td>
                <td>วัดคอนเวอร์ชันจากโฆษณา (เมื่อยินยอม)</td>
                <td>90 วัน</td>
                <td>Third-party</td>
              </tr>
              <tr>
                <td>Marketing</td>
                <td><code>_fbp</code></td>
                <td>Facebook Pixel</td>
                <td>วัดประสิทธิภาพโฆษณา/รีมาร์เก็ตติ้ง (เมื่อยินยอม)</td>
                <td>3 เดือน</td>
                <td>Third-party</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="ckp-note">
          * รายการด้านบนเป็นตัวอย่างคุกกี้ที่พบได้บ่อยและอาจมีการเปลี่ยนแปลงตามฟีเจอร์/แคมเปญ
          โดยเราจะอัปเดตหน้านี้เมื่อมีการเปลี่ยนแปลงสำคัญ
        </p>
      </section>

      <section>
        <h2>การจัดการคุกกี้ผ่านเบราว์เซอร์</h2>
        <p>
          คุณสามารถลบ/บล็อกคุกกี้ผ่านการตั้งค่าเบราว์เซอร์ของคุณได้
          อย่างไรก็ตาม การปิดคุกกี้บางประเภทอาจทำให้ฟังก์ชันบางอย่างของเว็บไซต์ทำงานได้ไม่สมบูรณ์
        </p>
      </section>

      <section>
        <h2>การเปลี่ยนแปลงนโยบาย</h2>
        <p>
          เราอาจปรับปรุงนโยบายคุกกี้เป็นครั้งคราวเพื่อให้สอดคล้องกับการดำเนินงานหรือกฎหมายที่เกี่ยวข้อง
          โปรดตรวจสอบหน้านี้เป็นระยะเพื่อรับทราบข้อมูลล่าสุด
        </p>
      </section>

      <section>
        <h2>ติดต่อเรา</h2>
        <p>
          หากมีคำถามเกี่ยวกับนโยบายคุกกี้ของเรา โปรดติดต่อผ่านหน้า <a href="/contact">ติดต่อเรา</a>
          หรืออีเมลฝ่ายดูแลลูกค้า (ถ้ามี)
        </p>
      </section>

      <style>{`
        .ckp-wrap{
          max-width: 980px;
          margin: 24px auto 80px;
          padding: 0 16px;
          color: #0b1220;
        }
        .ckp-hero{
          background: #0a3b86;
          color: #fff;
          border-radius: 12px;
          padding: 22px 18px;
          margin-bottom: 18px;
        }
        h1{ font-size: 1.75rem; margin: 0 0 6px; }
        h2{ font-size: 1.35rem; margin: 22px 0 10px; }
        h3{ font-size: 1.05rem; margin: 14px 0 8px; }

        .ckp-btn{
          display: inline-flex; align-items: center; justify-content: center;
          padding: 10px 16px; border-radius: 10px; border: none;
          background: linear-gradient(135deg,#0ea5e9,#3b82f6);
          color: #fff; font-weight: 700; cursor: pointer;
          transition: filter .15s, transform .06s;
          margin-top: 8px;
        }
        .ckp-btn:hover{ filter: brightness(1.05); }
        .ckp-btn:active{ transform: translateY(1px); }

        .ckp-table-wrap{ overflow-x: auto; }
        .ckp-table{
          width: 100%;
          border-collapse: collapse;
          background: #fff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 18px rgba(0,0,0,.06);
        }
        .ckp-table th, .ckp-table td{
          padding: 12px 10px; text-align: left; vertical-align: top;
          border-bottom: 1px solid #eef2f7;
          font-size: .95rem;
        }
        .ckp-table th{ background: #f7f9fc; font-weight: 700; }
        .ckp-table code{ background: #f2f6ff; padding: 2px 6px; border-radius: 6px; }

        .ckp-note{ font-size: .9rem; color: #4b5563; margin-top: 8px; }

        @media (max-width: 640px){
          .ckp-hero{ padding: 16px 14px; }
          .ckp-table th, .ckp-table td{ padding: 10px 8px; font-size: .9rem; }
        }
      `}</style>
    </div>
  );
}
